import { render, staticRenderFns } from "./ConfigSupplierForm.vue?vue&type=template&id=7c8f6236&scoped=true"
import script from "./ConfigSupplierForm.vue?vue&type=script&lang=js"
export * from "./ConfigSupplierForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigSupplierForm.vue?vue&type=style&index=0&id=7c8f6236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f6236",
  null
  
)

export default component.exports